import React, { useState } from 'react';
import { PrimaryButton, EditButton, CloseButton } from './Buttons';
import { useUser } from '../context/UserContext';
import { toast } from 'react-toastify';
import axiosInstance from '../services/api/axios';

function ProjectSettings({ project, onProjectUpdate }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedValue, setEditedValue] = useState(30);
  const [loading, setLoading] = useState(false);
  const { userInfo } = useUser();

  // Initialize edited value when entering edit mode
  const handleEdit = () => {
    const currentValue = project?.configuration?.dripFlagLastMessageSentThreshold || 30;
    setEditedValue(currentValue);
    setIsEditing(true);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const configuration = {
        ...project?.configuration,
        dripFlagLastMessageSentThreshold: editedValue
      };

      // Create FormData for the request with all required project fields
      const formData = new FormData();
      formData.append('project_name', project?.projectName || '');
      formData.append('developer', project?.developer || '');
      formData.append('customer_id', project?.customerId || '');
      formData.append('address_building_no', project?.address?.buildingNo || '');
      formData.append('address_street_name1', project?.address?.streetName1 || '');
      formData.append('address_city', project?.address?.city || '');
      formData.append('address_district', project?.address?.district || '');
      formData.append('address_pin_code', project?.address?.pinCode || '');
      formData.append('address_state', project?.address?.state || '');
      formData.append('address_country', project?.address?.country || '');
      formData.append('towers', project?.towers || '');
      formData.append('size_acres', project?.sizeAcres || '');
      formData.append('configuration', JSON.stringify(configuration));

      // Make PUT request to /projects with projectId and loginId as query parameters
      await axiosInstance.put(
        `/projects?projectId=${project.projectId}&loginId=${userInfo?.loginId}`,
        formData
      );

      // Update the project object immediately with the new value
      if (onProjectUpdate) {
        const updatedProject = {
          ...project,
          configuration: {
            ...project.configuration,
            dripFlagLastMessageSentThreshold: editedValue
          }
        };
        onProjectUpdate(updatedProject);
      }

      toast.success('Drip flag threshold updated successfully');
      setIsEditing(false);
    } catch (error) {
      console.error('Error updating drip flag threshold:', error);
      toast.error('Failed to update drip flag threshold');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setEditedValue(project?.configuration?.dripFlagLastMessageSentThreshold || 30);
    setIsEditing(false);
  };

  if (!project) return null;

  const currentValue = project?.configuration?.dripFlagLastMessageSentThreshold || 30;

  return (
    <div className="flex items-center justify-end space-x-2">
      <div className="flex items-center space-x-2 text-sm text-gray-600">
       
        <span>Drip Flag:</span>
        {isEditing ? (
          <div className="flex items-center space-x-2">
            <input
              type="number"
              value={editedValue}
              onChange={(e) => setEditedValue(parseInt(e.target.value) || 0)}
              className="w-16 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-flamingo-500"
              min="0"
            />
            <PrimaryButton
              onClick={handleSave}
              disabled={loading}
              className="p-2 w-24"
            >
             Save
            </PrimaryButton>
            <CloseButton
              onClick={handleCancel}
              disabled={loading}
             
            >
            
            </CloseButton>
          </div>
        ) : (
          <div className="flex items-center space-x-2">
            <span className="font-medium text-gray-900">{currentValue}</span>
            <EditButton
              onClick={handleEdit}
              
            >
             
            </EditButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProjectSettings;
